import PropTypes from 'prop-types';

// A collapsed <details> doesn't reliably open on fragment navigation, so open it before the jump.
export const openSection = (e) => {
  document.getElementById(e.currentTarget.hash.slice(1)).open = true;
};

export const Section = ({ id, title, open, children }) => (
  <details id={id} open={open} className="pb-6 border-b border-gray-200 group scroll-mt-8">
    <summary className="flex items-center justify-between gap-4 list-none cursor-pointer [&::-webkit-details-marker]:hidden">
      <h2 className="mb-0 text-3xl text-black lg:text-4xl">{title}</h2>
      <svg
        className="w-6 h-6 text-black transition-transform shrink-0 group-open:rotate-180"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </summary>
    <div className="flex flex-col gap-6 pt-6">{children}</div>
  </details>
);

Section.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  children: PropTypes.node
};
